import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Pointer = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    d: "M20.978 13.21a1 1 0 00-.396-1.024l-14-10a.999.999 0 00-1.575.931l2 17a1 1 0 001.767.516l3.612-4.416 3.377 5.46 1.701-1.052-3.357-5.428 6.089-1.218a.995.995 0 00.782-.769zm-8.674.31a1 1 0 00-.578.347l-3.008 3.677L7.257 5.127l10.283 7.345-5.236 1.048z",
    key: "k0"
  }));
});
Pointer.displayName = 'Pointer';
export var PointerDimensions = {
  height: 24,
  width: 24
};